/* [BD feat] Tom 2026-09-16 — SEO: the UpCart app renders its cart title ("Dein Warenkorb") and empty-state text
   ("Dein Warenkorb ist leer.") as <h3>. This swaps each for <div class="bd-upcart-title"> once UpCart has rendered it;
   theme.css (.bd-upcart-title) reproduces the h3 styling 1:1.

   UpCart is a React app and keeps references to the original <h3> nodes, so React keeps owning them:
   - the <h3> stays intact (detached) and React keeps updating it; the <div> shows a copy of its content that is
     refreshed on every change (text, children, attributes), so React never touches the <div>;
   - when React removes or inserts relative to a swapped <h3>, the calls are redirected to its <div>;
   - when React re-inserts the <h3> itself, the <div> is dropped first and the swap runs again. */
(function () {
  var SELECTOR = '#CartPopup h3[data-upcart-chunk="header-title-content"], #CartPopup .styles_CartPreview__empty__ > h3';
  var KEY = '__bdUpcartReplacement';

  function syncAttributes(from, to) {
    for (var i = 0; i < from.attributes.length; i++) {
      to.setAttribute(from.attributes[i].name, from.attributes[i].value);
    }
    to.classList.add('bd-upcart-title');
  }

  function swap(heading) {
    if (heading[KEY] && heading[KEY].isConnected) return;
    var replacement = document.createElement('div');

    function mirror() {
      syncAttributes(heading, replacement);
      var copies = [];
      heading.childNodes.forEach(function (child) { copies.push(child.cloneNode(true)); });
      replacement.replaceChildren.apply(replacement, copies);
    }

    mirror();
    heading[KEY] = replacement;
    heading.parentNode.replaceChild(replacement, heading);

    heading.__bdUpcartObserver = new MutationObserver(mirror);
    heading.__bdUpcartObserver.observe(heading, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  function restore(heading) {
    var replacement = heading[KEY];
    if (!replacement) return;
    if (heading.__bdUpcartObserver) heading.__bdUpcartObserver.disconnect();
    if (replacement.parentNode) replacement.parentNode.removeChild(replacement);
    heading[KEY] = null;
  }

  var nativeRemoveChild = Node.prototype.removeChild;
  var nativeInsertBefore = Node.prototype.insertBefore;

  Node.prototype.removeChild = function (child) {
    var replacement = child && child[KEY];
    if (replacement && child.parentNode !== this && replacement.parentNode === this) {
      nativeRemoveChild.call(this, replacement);
      return child;
    }
    return nativeRemoveChild.call(this, child);
  };

  Node.prototype.insertBefore = function (node, reference) {
    if (node && node[KEY]) restore(node);
    var replacement = reference && reference[KEY];
    if (replacement && reference.parentNode !== this && replacement.parentNode === this) {
      reference = replacement;
    }
    return nativeInsertBefore.call(this, node, reference);
  };

  var nativeAppendChild = Node.prototype.appendChild;
  Node.prototype.appendChild = function (node) {
    if (node && node[KEY]) restore(node);
    return nativeAppendChild.call(this, node);
  };

  var scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll(SELECTOR).forEach(swap);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
/* [/BD feat] */
